import React, { useState } from "react";
import PropTypes from "prop-types";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { AiOutlineCopyrightCircle } from "react-icons/ai";
import { IconButton } from "@mui/material";

const propTypes = {
  textToCopy: PropTypes.string,
  title: PropTypes.string,
  iconClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  callBack: PropTypes.func,
};

const defaultProps = {};

export default function CopyButton(props) {
  const {
    textToCopy,
    title,
    iconClassName,
    buttonClassName,
    callBack,
    copyType = false,
  } = props;
  
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(textToCopy);
    setIsCopied(true);
    
    // Reset after 1.5 seconds
    setTimeout(() => {
      setIsCopied(false);
    }, 1500);
    
    callBack && callBack();
  };

  return (
    <IconButton
      title={isCopied ? "Copied!" : (title || `Copy ${textToCopy}`)}
      className={buttonClassName}
      size="small"
      onClick={handleCopy}
      sx={{
        padding: "4px !important",
        width: "28px !important",
        height: "28px !important",
        minWidth: "28px !important",
        minHeight: "28px !important",
        transition: "all 0.3s ease",
        "& svg": { 
          fontSize: "20px !important",
          width: "20px !important",
          height: "20px !important",
          transition: "all 0.3s ease",
          color: isCopied ? "#4CAF50 !important" : "inherit",
        }
      }}
    >
      {!copyType && !isCopied && (
        <ContentCopyIcon className={iconClassName} fontSize="small" />
      )}
      {!copyType && isCopied && (
        <CheckCircleIcon className={iconClassName} fontSize="small" />
      )}
      {copyType && (
        <AiOutlineCopyrightCircle className={iconClassName} fontSize="small" />
      )}
    </IconButton>
  );
}

CopyButton.propTypes = propTypes;
CopyButton.defaultProps = defaultProps;
